import styled from 'styled-components'

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Title = styled.main`
  max-width: 1040px;
  width: 90%;
  border-left: 8px solid #35bdac;
  margin-bottom: 20px;

  h1 {
    margin-left: 12px;
    font-size: 28px;
  }
`

export const WrapperCards = styled.div`
  max-width: 1040px;
  width: 90%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`
